import { CreateLinkTo } from '../constants/linkTo';

export function copyLinkProject(projectId: string, toasts?: any, t?: any) {
    navigator.clipboard
        .writeText(window.location.origin + CreateLinkTo.project(projectId))
        .then(() => toasts.info(t && t('link_copied')));
}

export function copyLinkFolder(folderId: string, profileId: string, toasts?: any, t?: any) {
    navigator.clipboard
        .writeText(window.location.origin + CreateLinkTo.designer(profileId) + `?folderId=${folderId}`)
        .then(() => toasts.info(t && t('link_copied')));
}
export function createCopyLinkProjectFn(toasts?: any, t?: any) {
    return (projectId: string) => copyLinkProject(projectId, toasts, t);
}

export function copyLinkDesigner(designerId: string, toasts?: any, t?: any) {
    navigator.clipboard
        .writeText(window.location.origin + CreateLinkTo.designer(designerId))
        .then(() => toasts.info(t && t('link_copied')));
}

export function createCopyLinkDesignerFn(toasts?: any, t?: any) {
    return (designerId: string) => copyLinkDesigner(designerId, toasts, t);
}
import { CreateLinkTo } from '../constants/linkTo';

export function copyLinkProject(projectId: string, toasts?: any, t?: any) {
    navigator.clipboard
        .writeText(window.location.origin + CreateLinkTo.project(projectId))
        .then(() => toasts.info(t && t('link_copied')));
}

export function copyLinkFolder(folderId: string, profileId: string, toasts?: any, t?: any) {
    navigator.clipboard
        .writeText(window.location.origin + CreateLinkTo.designer(profileId) + `?folderId=${folderId}`)
        .then(() => toasts.info(t && t('link_copied')));
}
export function createCopyLinkProjectFn(toasts?: any, t?: any) {
    return (projectId: string) => copyLinkProject(projectId, toasts, t);
}

export function copyLinkDesigner(designerId: string, toasts?: any, t?: any) {
    navigator.clipboard
        .writeText(window.location.origin + CreateLinkTo.designer(designerId))
        .then(() => toasts.info(t && t('link_copied')));
}

export function createCopyLinkDesignerFn(toasts?: any, t?: any) {
    return (designerId: string) => copyLinkDesigner(designerId, toasts, t);
}
